module.exports = __webpack_public_path__ + "img/partner_01.df4c55ed.jpg";